export default __webpack_public_path__ + "static/media/c5.522988f1.png";